export const GOOGLE_FONTS_API_KEY = "AIzaSyDzwaKOlGfQ-dBISlXCmt-KuTrN-_NrdoY";
export const listGoogleFontsUrl = `https://www.googleapis.com/webfonts/v1/webfonts?key=${GOOGLE_FONTS_API_KEY}&sort=alpha`;
export const fontsToLoad = [
  "Cardo",
  "Crimson Text",
  "EB Garamond",
  "Fanwood Text",
  "IM Fell Double Pica",
  "IM Fell French Canon",
  "Sorts Mill Goudy",
];